import React from 'react'
import PropTypes from 'prop-types'
import { Heading } from '@chakra-ui/react'

const RegisterWidgetTitle = ({ data, theme, dataTestId }) => {
  return (
    <Heading
      as='h2'
      color={theme.textColor}
      fontFamily='heading'
      fontSize={`${theme.titleFontSize}em` || 'heading'}
      fontWeight={theme.titleFontWeight || 'heading'}
      wordBreak='break-word'
      data-testid={dataTestId}
    >
      {data.title}
    </Heading>
  )
}

RegisterWidgetTitle.propTypes = {
  data: PropTypes.object,
  theme: PropTypes.object,
  dataTestId: PropTypes.string.isRequired
}

export default RegisterWidgetTitle
